import React from "react";
import { logo, title } from "../config/Config";
import { Link, useLocation } from "react-router-dom";
import { EmailRounded, PhoneInTalkRounded, PinDropRounded, } from "@mui/icons-material";
import { email, main_address, phone_number} from "../config/details";
import Mode_logo from "../Assets/images/logo.png";

const Footer = () => {
  let location= useLocation();
  return (
    <>
      <footer id="footer" className="main-footer">
        <div className="container-layout">
          <div className="footer-sec">
            <div className="row">
              <div className="col-lg-4 left-column-footer">
                <div className="top-logo">
                  <img src={logo} alt={title + "Logo"} />
                  <img src={Mode_logo} alt={title + "Logo"} />
                </div>
                <h1> Innovate Success. <br /> Elevate Tomorrow. </h1>
              </div>

              <div className="col-lg-8 right-column-footer">
                <div className="row m-0">
                  <div className="col-md-3">
                    <h6>Useful Links</h6>
                    <ul className="nav flex-column">

                      <li className={`${location.pathname === "/" && "footer_active_Link"} nav-item`}>
                        <Link to="/" className="nav-link">Home </Link>
                      </li>

                      <li className={`${location.pathname === "/about" && "footer_active_Link"} nav-item`}>
                        <Link to="/about" className="nav-link">About </Link>
                      </li>

                      <li className={`${location.pathname === "/portfolio" && "footer_active_Link"} nav-item`}>
                        <Link to="/portfolio" className="nav-link">Portfolio </Link>
                      </li>

                      <li className={`${location.pathname === "/blog" && "footer_active_Link"} nav-item`}>
                        <Link to="/blog" className="nav-link">Blog </Link>
                      </li>

                      <li className={`${location.pathname === "/contact" && "footer_active_Link"} nav-item`}>
                        <Link to="/contact" className="nav-link"> Contact us</Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col-md-5">
                    <h6>Our Services</h6>

                    <ul className="nav flex-column">
                      <li className={`${location.pathname === "/web-design" && "footer_active_Link"} nav-item`}>
                        <Link to="/web-design" className="nav-link"> Website designing  </Link>
                      </li>

                      <li className={`${location.pathname === "/webdeveloper" && "footer_active_Link"} nav-item`}>
                        <Link to="/webdeveloper" className="nav-link">Website development </Link>
                      </li>

                      <li className={`${location.pathname === "/wordpress" && "footer_active_Link"} nav-item`}>
                        <Link to="/wordpress" className="nav-link"> wordpress website design </Link>
                      </li>

                      <li className={`${location.pathname === "/search-engine" && "footer_active_Link"} nav-item`}>
                        <Link to="/search-engine" className="nav-link"> search engine optimization </Link>
                      </li>

                      <li className={`${location.pathname === "/webhosting" && "footer_active_Link"} nav-item`}>
                        <Link to="/webhosting" className="nav-link"> Web Hosting</Link>
                      </li>

                      <li className={`${location.pathname === "/email-hosting" && "footer_active_Link"} nav-item`}>
                        <Link to="/email-hosting" className="nav-link"> bulk sms & email hosting </Link>
                      </li>

                      {/* <li className={`${location.pathname === "/mobile-app" && "footer_active_Link"} nav-item`}>
                        <Link to="/mobile-app" className="nav-link"> Mobile Apps </Link>
                      </li> */}
                    </ul>
                  </div>

                  <div className="col-md-4">
                    <h6>Contact Info</h6>
                    <ul className="nav flex-column">
                      <li className="nav-item nav-address">
                        <span><PhoneInTalkRounded /> </span>
                        <div className="">
                          <a target="_black" href={`tel:${phone_number}`}>{`+91` + phone_number}</a>
                        </div>
                      </li>
                        <li className="nav-item nav-address">
                        <span><PinDropRounded /> </span>
                        <div className="">
                         {main_address}
                        </div>
                      </li>
{/* 
                      <li className="nav-item nav-address">
                        <span><PhoneInTalkRounded /> </span>
                        <div className="">
                          <a target="_black" href={`tel:${phone_number2}`}>{`+91 ` + phone_number2}</a>
                        </div>
                      </li>

                      <li className="nav-item nav-address">
                        <span><PhoneInTalkRounded /> </span>
                        <div className="">
                          <a target="_black" href={`tel:${phone_number3}`}>{`+91 ` + phone_number3}</a>
                        </div>
                      </li> */}

                      <li className="nav-item nav-address">
                        <span><EmailRounded /></span>
                        <div className="">
                          <a target="_black" href={`mailto:${email}`}>{email}</a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* <div className="col-12">
                <div className="address-section-footer">
                  <ul className="nav">
                    <li className="nav-item">
                      <span><PinDropRounded /> </span>
                      <div className="">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address)}`} target="_blank" rel="noopener noreferrer" > {main_address}</a>
                      </div>
                    </li>

                    <li className="nav-item">
                      <span><PinDropRounded /> </span>
                      <div className="">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address)}`} target="_blank" rel="noopener noreferrer">{first_address}</a>
                      </div>
                    </li>

                    <li className="nav-item">
                      <span><PinDropRounded /> </span>
                      <div className="">
                        <a href={`https://www.google.com/maps?q=${encodeURIComponent(main_address )}`} target="_blank" rel="noopener noreferrer" > {second_address}</a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div> */}

            </div>
          </div>
        </div>

        <div className="copyright-txt">
          <p> Copyright © 2019-{new Date().getFullYear()} {title} LLP. All Rights Reserved. </p>
          </div>
      </footer>
    </>
  );
};

export default Footer;
